import styled from 'styled-components';

import { PushContentDefinition } from 'modules/graphql/types';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Tooltip } from 'ui/tooltip';

import { TemplateEditViews } from '../../common/types';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { SettingsReadOnlyText } from '../../common/EditorContentContainer.styled';

const StyledReadOnlyText = styled(SettingsReadOnlyText)`
  overflow-wrap: anywhere;
`;

export const CustomSound = () => {
  const { view } = useQueryParamContext();
  const {
    isEditMode: isEditModeContext,
    liveTemplate,
    setCurrentMediumField,
  } = useEditableFieldsContext();
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;

  const isEditMode = view === TemplateEditViews.preview || isEditModeContext;

  const getReadOnlyText = () => {
    if (pushData.isSilentPush) {
      return SETTINGS_DISPLAY_CONTENT.deliverSilently.silenced;
    }
    if (pushData.sound && pushData.sound.length > 0) {
      return pushData.sound;
    }
    return SETTINGS_DISPLAY_CONTENT.unsetText;
  };

  return (
    <>
      <FormField
        isDisabled={pushData.isSilentPush}
        isHorizontalLayout
        labelText={SETTINGS_DISPLAY_CONTENT.customSound.labelText}
      >
        {isEditMode ? (
          <Tooltip
            isEnabled={pushData.isSilentPush}
            tooltipContent={SETTINGS_DISPLAY_CONTENT.deliverSilently.restriction}
          >
            <InputText
              id="settings-template-push-custom-sound"
              data-test="settings-template-push-custom-sound"
              isDisabled={pushData.isSilentPush}
              placeholder={SETTINGS_DISPLAY_CONTENT.customSound.placeholder}
              onChange={(sound) => setCurrentMediumField('sound', sound)}
              value={pushData.sound || ''}
              width="100%"
            />
          </Tooltip>
        ) : (
          <StyledReadOnlyText isUnset={!pushData.sound} data-test="custom-sound-ro">
            {getReadOnlyText()}
          </StyledReadOnlyText>
        )}
      </FormField>
    </>
  );
};
